import React from 'react';
import { ServerComponentCaller } from '../../helpers';

const FileManager = (props) => (
  <ServerComponentCaller url={'/assets/data/schema/FileManager.json'} />
);

export default FileManager;
